import React from 'react';
import { Outlet } from 'react-router';

import styled from 'styled-components';

import { ErrorBoundaryReset } from 'components/error/ErrorBoundary';

import Footer from '../../footer/Footer';

const MainLayout = () => {
  return (
    <OnlyMainPageStyled id="mainLayout">
      <ErrorBoundaryReset>
        <Outlet />
      </ErrorBoundaryReset>
      <Footer />
    </OnlyMainPageStyled>
  );
};
export default MainLayout;

const OnlyMainPageStyled = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
`;
